import { render } from "./Loader.vue?vue&type=template&id=ac562ee8&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=ac562ee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac562ee8"]])

export default __exports__